import { FetchEventsResponse } from "../../../types/apiResponsesTypes";
import GenericTable from "../GenericTable";
import "./TableEvents.scss";
import { useNavigate } from "react-router-dom";
import useTableEvents from "./hooks/useTableEvents";
import { Card } from "antd";
import { EventPartial } from "../../../types/events";

type Props = {
  eventsData: FetchEventsResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onDelete: (id: number) => void;
};

const TableEvents: React.FC<Props> = ({
  eventsData,
  fetchData,
  onDelete,
  isLoading,
}) => {
  const navigate = useNavigate();

  const { columns, onRowClick } = useTableEvents({ navigate, onDelete });

  return (
    <Card title="ÃvÃ©nemens Ã  traiter" bordered={false}>
      <GenericTable<EventPartial>
        results={eventsData?.results || []}
        count={eventsData?.count || 0}
        columns={columns}
        fetchData={fetchData}
        isLoading={isLoading}
        onRow={onRowClick}
        direction={["descend"]}
      />
    </Card>
  );
};

export default TableEvents;
